import { Card, Flex, Text } from "@suns/design-system";
import { NavLink } from "react-router-dom";

export function PageNotFound() {
  return (
    <Card>
      <Flex
        className="h-[400px]"
        direction="down"
        justify="center"
        align="center"
        gap="lg"
      >
        <Flex direction="down" align="center" gap="md">
          <Text size="9xl" heading>
            404
          </Text>
          <Text size="2xl" heading>
            Page Not Found
          </Text>
          <Text size="xl">
            The page you're looking for does not seem to exist.
          </Text>
        </Flex>
        <NavLink to="/" className="btn min-w-48 text-center">
          Go to Home
        </NavLink>
      </Flex>
    </Card>
  );
}
